import React from "react";

export default function Terms() {
  return (
    <div className="_w-100 text-bg-dark text-white pt-5 pb-5 mt-3 information">
      <div className="m-auto pt-3">
        <h1>Terms and Conditions</h1>
        <span>Last Revised: April 10, 2024</span>

        <p>
          These Terms and Conditions govern the use of our Site and services. By
          accessing or using our Service, you agree to be bound by these Terms.
          If you do not agree with these Terms, please refrain from using our
          service.
        </p>

        <ul>
          <li>
            <h2>General</h2>
            <ol>
              <li>
                Service Definition: The Site and its contents are considered our
                Service. By using our Service, you acknowledge and accept these
                Terms.
              </li>
              <li>
                Acceptance: Registering for any account or subscription on our
                Service requires you to indicate your acceptance of these Terms.
                This forms a binding agreement between you and us.
              </li>
              <li>
                Modifications: We reserve the right to change these Terms at our
                sole discretion. You are responsible for checking this page
                periodically for updates, which will be binding upon posting.
              </li>
            </ol>
          </li>
          <li>
            <h2>The Site</h2>
            <ol>
              <li>
                Nature of Service: The Site is free and intended for
                informational purposes only.
              </li>
              <li>
                Non-Operation: Casino Rate does not operate any online casino,
                poker, or betting sites, nor does it accept any cash, bets, or
                wagers.
              </li>
              <li>
                Age Restriction: You must be over 18 or the legal age for using
                the Site in your jurisdiction.
              </li>
              <li>
                Jurisdiction: Our Service is intended only for Users in
                jurisdictions where the use of such information is legal.
              </li>
              <li>
                Third-Party Links: The Site may contain links to third-party
                services or websites. We are not responsible for their content,
                security, or privacy practices. Using these links is at your own
                risk.
              </li>
              <li>
                Endorsement Disclaimer: A link to a third-party site does not
                imply endorsement. You are responsible for determining the
                legality and appropriateness of using any third-party service.
              </li>
              <li>
                No Warranty: We do not make any warranties about the accuracy or
                quality of third-party content.
              </li>
              <li>
                Advice Disclaimer: No information on the Site should be
                considered as advice or recommendation on betting or gambling.
              </li>
              <li>
                Liability: We have no control over and are not responsible for
                the actions of any Gambling Operator, including accepting bets
                or making payments.
              </li>
              <li>
                Social Media: These Terms also apply to content we post on our
                social media accounts.
              </li>
              <li>
                Service Interruptions: We may occasionally suspend or restrict
                access to our Service for maintenance or updates. We do not
                guarantee uninterrupted or error-free access.
              </li>
              <li>
                Promotions: Competitions or promotions on our Service are
                subject to their own terms and may not be available in all
                jurisdictions.
              </li>
            </ol>
          </li>
          <li>
            <h2>Use of the Site</h2>
            <ol>
              <li>
                Illegal Activities: Engage in activities that breach any law or
                regulation.
              </li>
              <li>Fraud: Engage in fraudulent activities.</li>
              <li>Harm: Harm minors or any other individuals.</li>
              <li>
                Intellectual Property: Use material that violates our or
                third-party intellectual property rights.
              </li>
              <li>Spam: Send unsolicited promotional material.</li>
              <li>
                Downloads: Download information, content, or materials without
                permission.
              </li>
              <li>Malware: Transmit any harmful software.</li>
              <li>
                Interference: Access or interfere with our Service or any
                related systems without authorization.
              </li>
            </ol>
          </li>
          <li>
            <h2>User Warranties</h2>
            <p>
              You acknowledge that gambling laws vary worldwide, and it is your
              responsibility to comply with the applicable laws in your
              jurisdiction. By using our Service, you confirm that:
            </p>
            <ol>
              <li>
                Legality: You are in a jurisdiction where it is legal to use our
                Service.
              </li>
              <li>Age: You are over 18 or the age of legal consent.</li>
              <li>Compliance: You will not violate any applicable laws.</li>
              <li>
                Financial Responsibility: You are responsible for any losses
                incurred through gambling.
              </li>
              <li>
                Requirement Verification: You will verify any usage
                requirements.
              </li>
              <li>
                Risk: Your use of any Gambling Operator is at your own risk.
              </li>
              <li>
                Legal Understanding: You understand the gambling laws in your
                jurisdiction.
              </li>
              <li>
                No Illegal Use: You will not use our Service for illegal
                purposes.
              </li>
              <li>No Impersonation: You will not impersonate others.</li>
              <li>
                Waiver of Class Action: You waive any right to participate in a
                class action or jury trial against us.
              </li>
            </ol>
            <p>
              If you use the Site on behalf of an entity, you represent that you
              are authorized to bind that entity to these Terms.
            </p>
          </li>
          <li>
            <h2>Intellectual Property Rights</h2>
            <p>
              We own or license all intellectual property rights in our Service.
              You do not gain any rights to our trademarks or content by using
              our Service. Copying or distributing our Service for commercial
              purposes is prohibited without our prior written consent.
            </p>
          </li>
          <li>
            <h2>Intellectual Property Infringement</h2>
            <p>
              If you believe that your intellectual property rights are being
              infringed upon, notify us with the following information:
            </p>
            <ol>
              <li>
                Your Information: Your name, entity (if applicable), contact
                information, and a signature of the intellectual property owner
                or authorized agent.
              </li>
              <li>
                Infringement Details: Details of the alleged infringement and
                proof of ownership.
              </li>
              <li>
                <h2>Disclaimer</h2>
                <p>
                  Our Service is provided "as is" without any warranties. We do
                  not guarantee uninterrupted or error-free access and disclaim
                  any responsibility for the accuracy, completeness, or
                  availability of information on third-party sites linked to our
                  Service.
                </p>
              </li>
              <li>
                <h2>Indemnity</h2>
                <p>
                  You agree to indemnify us and our affiliates against any
                  losses or damages arising from your breach of these Terms.
                </p>
              </li>
              <li>
                <h2>Limitation of Liability</h2>
                <p>
                  We are not liable for any direct, indirect, incidental, or
                  consequential damages arising from your use of our Service.
                  Our total liability is limited to the amount you paid, if any,
                  or $100 USD, whichever is less.
                </p>
              </li>
              <li>
                <h2>Termination</h2>
                <p>
                  We may terminate your access to the Site without notice for
                  any reason, including breach of these Terms. Upon termination,
                  you must stop using our Service and delete any copies in your
                  possession.
                </p>
              </li>
            </ol>
          </li>
        </ul>
        <p>Severability and No Third-Party Rights</p>
        <p>
          If any provision of these Terms is invalid, the remaining provisions
          will continue in effect. These Terms do not create any third-party
          rights or relationships.
        </p>
      </div>
    </div>
  );
}
